import { TextInputFormikPropTypes, TextInputFormikDefaultProps } from '../../Utils/TextInputPropTypes';

export const propTypes = TextInputFormikPropTypes;
export const defaultProps = TextInputFormikDefaultProps;

export default { propTypes, defaultProps };
